var _path, _rect, _rect2, _path2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _path3, _path4, _rect11, _rect12, _rect13, _rect14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElmartTimeline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1221,
    height: 157,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.639 69.53l62.898-31.445a3.996 3.996 0 011.313-.394l144.128-17.287c.91-.11 1.83.097 2.606.586l154.233 97.06a3.996 3.996 0 001.668.587l233.475 27.15a4.004 4.004 0 003.145-1.006L748.1 30.845a3.999 3.999 0 012.448-1.026l266.032-15.652c.55-.032 1.1.049 1.61.238l185.47 68.098",
    stroke: "#848484",
    strokeWidth: 1.5,
    strokeDasharray: "4 4"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.412,
    y: 50.747,
    width: 39.305,
    height: 39.305,
    rx: 19.653,
    fill: "#fff",
    fillOpacity: 0.2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6.666,
    y: 57,
    width: 26.728,
    height: 26.728,
    rx: 13.364,
    fill: "#161616"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.518 75.84A1.613 1.613 0 0118.001 78a1.61 1.61 0 01-1.61-1.613c0-.536.26-1.011.664-1.305l-.01-.027-3.67-10.934H11.56a.56.56 0 010-1.121h2.176c.154 0 .294.062.396.164.058.051.11.116.154.208l.964 2.84 13.206-.017c.499 0 .533.359.434.622l-.444 1.39c-.206.643-.42 1.254-.626 1.873l-.926 2.788c-.099.297-.15.646-.502.724a3.64 3.64 0 01-.554.028l-8.077-.004.335 1.162h6.926a1.61 1.61 0 11-1.517 1.063h-3.988z",
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 212.955,
    y: 7.56,
    width: 23.583,
    height: 23.583,
    rx: 11.792,
    fill: "#949494"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 216.809,
    y: 11.414,
    width: 15.414,
    height: 15.414,
    rx: 7.707,
    fill: "#fff"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 374.939,
    y: 108.132,
    width: 23.583,
    height: 23.583,
    rx: 11.792,
    fill: "#949494"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 378.793,
    y: 111.985,
    width: 15.414,
    height: 15.414,
    rx: 7.707,
    fill: "#fff"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 608.955,
    y: 132.867,
    width: 23.583,
    height: 23.583,
    rx: 11.792,
    fill: "#949494"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 612.809,
    y: 136.721,
    width: 15.414,
    height: 15.414,
    rx: 7.707,
    fill: "#fff"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 1181.62,
    y: 64.918,
    width: 39.305,
    height: 39.305,
    rx: 19.653,
    fill: "#fff",
    fillOpacity: 0.2
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 1187.91,
    y: 71.207,
    width: 26.728,
    height: 26.728,
    rx: 13.364,
    fill: "#161616"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1210.67 84.5h-2.11m0 0c0 1.96-.78 3.839-2.17 5.225a7.367 7.367 0 01-5.22 2.164m7.39-7.389c0-1.96-.78-3.84-2.17-5.226a7.366 7.366 0 00-5.22-2.163m0-2.111v2.111m0 0c-1.96 0-3.84.777-5.23 2.163a7.409 7.409 0 00-2.16 5.225c0 1.96.78 3.84 2.16 5.225a7.409 7.409 0 005.23 2.165m-9.5-7.389h2.11m7.39 9.5v-2.111",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1201.17 88.722c1.12 0 2.19-.445 2.98-1.236a4.233 4.233 0 001.24-2.986c0-1.12-.45-2.194-1.24-2.985a4.206 4.206 0 00-2.98-1.237 4.229 4.229 0 00-4.23 4.222 4.229 4.229 0 004.23 4.222z",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 734.615,
    y: 17.988,
    width: 23.583,
    height: 23.583,
    rx: 11.792,
    fill: "#949494"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 738.469,
    y: 21.841,
    width: 15.414,
    height: 15.414,
    rx: 7.707,
    fill: "#fff"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 1002.62,
    y: 0.988,
    width: 23.583,
    height: 23.583,
    rx: 11.792,
    fill: "#949494"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 1006.47,
    y: 4.841,
    width: 15.414,
    height: 15.414,
    rx: 7.707,
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElmartTimeline);
export default __webpack_public_path__ + "static/media/elmart-timeline.67b6e228acd8ca0ccc6f80cac9c859ae.svg";
export { ForwardRef as ReactComponent };